import { html } from 'uhtml';
import EDatagridSearchTemplate from './search';
import EDatagridFilterTemplate from './filter';
import classNames from 'clsx';
import EDatagridActionTemplate from './action';
import EDatagridBulkActionBarTemplate from './bulk-actions-bar';

export default class EDatagridHeaderTemplate {
  constructor(state, events, refs) {
    this._state = state;
    this._events = events;
    this._refs = refs;

    this._search = new EDatagridSearchTemplate(this._state, this._events, this._refs);
    this._filter = new EDatagridFilterTemplate(this._state, this._events);
    this._action = new EDatagridActionTemplate(this._state, this._events);
    this._bulkActionBar = new EDatagridBulkActionBarTemplate(this._state, this._events);
  }

  createPriorityButton() {
    if (!this._state.columnDefinitions.some(definition => definition.type === 'priority')) { return; }

    const buttonClass = classNames('e-btn e-btn-borderless', {
      'e-btn-active': this._state.priorityState.isPriorityModeOpen
    });

    return html`
      <div class="e-datagrid__priority_button">
        <button class="${buttonClass}" @click=${this._events.onPriorityModeButtonClick}>
          <e-icon icon="e-move-vertical"></e-icon>
          <e-translation key="components.datagrid.priority.enterPriorityModeButton"></e-translation>
        </button>
      </div>
    `;
  };

  createBulkToggleButton() {
    if (!this._state.bulkState.hasBulkToggle) { return; }

    const { icon, label } = this._state.bulkState.bulkToggle;
    const classList = classNames('e-datagrid__bulk_toggle e-btn e-btn-borderless', {
      'e-btn-active': this._state.bulkState.isBulkToggleActive
    });

    return html`
      <button class=${classList} @click=${this._events.onBulkToggleClick}>
        ${icon ? html`<e-icon icon=${icon}></e-icon>` : null}${label}
      </button>
    `;
  }

  createAdvancedFilter() {
    if (!this._state.filterState.hasAdvancedFilters) { return; }

    const filtersClass = classNames('e-datagrid__advanced_filters', {
      'e-hidden': !this._state.filterState.isFiltersOpen
    });

    return html`
      <div class="${filtersClass}">
        ${this._filter.createAdvanced()}
      </div>
    `;
  }

  create() {
    const isBulkVisible = this._state.bulkState.bulkActions.length &&
      this._state.bulkState.selectedItemsCount &&
      !this._state.priorityState.isPriorityModeOpen;

    if (!this._state.columnDefinitions.length) {
      return;
    } else if (
      this._state.filterState.isSearchHidden &&
      !this._state.actions.length &&
      !this._state.filterState.filters.length &&
      !isBulkVisible
    ) {
      return;
    }

    return html`
      <div class="e-datagrid__header">
        <div class="e-datagrid__header_left">
          ${this._search.create()}
          ${this._filter.createSimple()}
          ${this._filter.createAdvancedButton()}
          ${this.createPriorityButton()}
          ${this.createBulkToggleButton()}
        </div>
        <div class="e-datagrid__header_right">
          ${this._action.create()}
        </div>
        ${this.createAdvancedFilter()}
        ${this._bulkActionBar.create()}
      </div>
    `;
  }
}
